import React, { FC, forwardRef, ForwardRefRenderFunction } from 'react'
import * as SC from './styles'
import { Year } from '../../models/history'


type Props = {
  yearInfo: Year
  yearImage: "/static/images/circles.svg" | "/static/images/circles-inactive.svg"
  isReversed?: boolean
  isActive?: boolean
  href?: string
}

const YearCard: ForwardRefRenderFunction<HTMLAnchorElement, Props> = ({
  yearInfo,
  yearImage,
  isReversed = false,
  isActive = false,
  href
}, ref) => {
  return (
    <SC.YearCardRoot isActive={isActive} isReversed={isReversed} href={href} ref={ref}>
      <SC.Img
        src={yearImage}
        alt={`${yearInfo.currentYear}`}
      />
      <SC.Text>
        <SC.Title>{yearInfo.currentYear}</SC.Title>
        <SC.Span>{yearInfo.guests}</SC.Span>
        <SC.Span>{yearInfo.stages}</SC.Span>
        <SC.Span>{yearInfo.artists}</SC.Span>
        {yearInfo.additionalInfo &&
          yearInfo.additionalInfo.map((additionalInfo, index) => (
            <SC.Span key={index}>{additionalInfo}</SC.Span>
          ))}
      </SC.Text>
    </SC.YearCardRoot>
  )
}

export default forwardRef(YearCard)
